export const socialsData = {
    github: 'https://github.com/PruthilTejani',
    // facebook: 'https://www.facebook.com/',
    linkedIn: 'https://www.linkedin.com/in/pruthil-tejani-a4b8a9310',
    instagram: 'https://www.instagram.com/pruthilll__.25',
    // codepen: 'https://codepen.io/',
    // twitter: 'https://twitter.com/',
    // reddit: 'https://www.reddit.com/user/',
    // blogger: 'https://www.blogger.com/',
    // medium: 'https://medium.com/@',
    // stackOverflow: 'https://stackoverflow.com/users/',
    // gitlab: 'https://gitlab.com/',
    // youtube: 'https://youtube.com/'
}